import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "../styles/AdminLayout.css";

function AdminLayout({ activeKey, children }) {
  return (
    <div className="admin-layout">
      <Navbar />
      <div className="admin-layout-body">
        <Sidebar activeKey={activeKey} />
        <div className="admin-layout-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
